export const NAVBAR_HEIGHT = 64
export const HEADER_Z_INDEX = 999
